import api from "./api";
import { Nullable, ResponseInterface } from "../interfaces";
import { FileDocument } from "./shipmentServices";
import { DigitalDocsInterfaceRequest, DigitalDocsStatusInterface } from "../interfaces/DigitalDocsInterface";

const baseURLAPI = `${process.env.REACT_APP_API_HOST}/v1/Shipment`;

export const getDigitalDocsStatus = async (
  shipmentHeaderID: string
): Promise<ResponseInterface<DigitalDocsStatusInterface>> => {
  const uri = `${baseURLAPI}/GetShipmentDigitalDocsStatus/?ShipmentHeaderID=${shipmentHeaderID}`;
  try {
    const response = await api.get(uri);

    return response.data;

  } catch (error) {
    console.error("Error fetching digital docs status:", error);
    return {
      didError: true,
      message: "",
      errorMessage: "Failed to fetch digital docs status",
      model: null
    };
  }
};

export const getLiabilityWaiverDigitalDoc = async (
  request: DigitalDocsInterfaceRequest
): Promise<Nullable<FileDocument>> => {
  const uri = `${baseURLAPI}/DownloadDocumentDeliveryLiability`;
  try {
    const response = await api.post(uri, request, {
      headers: {
        "Content-Type": "application/json",
      },
      responseType: "blob",
    });

    if (response.status === 200) {
      return {
        file: response.data,
        fileName:
          "DigitalLiabilityWaiver_" + request.list[0].shipmentHeaderID + ".pdf",
      };
    }
  } catch (error) {
    console.error("Error downloading liability waiver digital document:", error);
  }
  return null;
};

export const getPODDigitalDoc = async (
  request: DigitalDocsInterfaceRequest
): Promise<Nullable<FileDocument>> => {
  const uri = `${baseURLAPI}/DownloadDocumentDeliveryDigital`;
  try {
    const response = await api.post(uri, request, {
      headers: {
        "Content-Type": "application/json",
      },
      responseType: "blob",
    });

    if (response.status === 200) {
      return {
        file: response.data,
        fileName: "DigitalPOD_" + request.list[0].shipmentHeaderID + ".pdf",
      };
    }
  } catch (error) {
    console.error("Error downloading POD digital document:", error);
  }
  return null;
};
